(() => {
  // Reopen Shopify's own consent manager; never change consent from a footer click.
  const connect = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return false;
    document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
      button.hidden = false;
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        try { await window.privacyBanner.showPreferences(); }
        catch { document.querySelector('#site-status').textContent = 'Les préférences de cookies n’ont pas pu être ouvertes. Rechargez la page pour réessayer.'; }
      });
    });
    return true;
  };
  let attempts = 0;
  const timer = setInterval(() => { if (connect() || ++attempts >= 20) clearInterval(timer); }, 500);
  connect();
  document.addEventListener('shopify:section:load', connect);
})();
